module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "./static/css/style.css"
    }
  }), _c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "./static/css/button3d.css"
    }
  }), _c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "./static/css/sweetalert.min.css"
    }
  }), _c('link', {
    attrs: {
      "href": "https://fonts.googleapis.com/css?family=Rubik",
      "rel": "stylesheet"
    }
  }), (_vm.$store.state.authorization) ? _c('main-header') : _vm._e(), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f0b2be6"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=jade!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 478
// module chunks = 2